@if (isLoading()) {
  <div @fadeIn class="loader" [ngClass]="{ overlay: !inline() }">
    <mat-spinner [diameter]="diameter()" [strokeWidth]="strokeWidth()"></mat-spinner>
  </div>
}
